import Grid from './components/grid'
import Dropdown from './components/dropdown'
import Calendar from './components/calendar'
import API from './api'

class CIndex {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[OAR index online]')
      this.emptyElement = document.querySelector('#js-empty')

      this.initFilters()
      this.initGrids()
      this.initCalendar()

      window.addEventListener('popstate', () => {
        window.location.reload()
      })
    })
  }

  initFilters() {
    this.query = new URL(document.location).searchParams
    this.filters = document.forms.filters

    // init checkboxes
    this.query.forEach((value, key) => {
      const input = this.filters.querySelector(
        `input[name='${key}'][value='${value}']`
      )

      if (input) input.checked = true
    })

    // init dropdowns
    const dropdowns = this.filters.querySelectorAll('.dropdown.is-filter')
    dropdowns.forEach((e) => {
      const dropdown = new Dropdown(e)
      dropdown.updateState()
      dropdown.onUpdate = this.onUpdate.bind(this, true)
    })
  }

  onUpdate(updateCalendar) {
    const formData = new FormData(this.filters)
    this.query = new URLSearchParams(formData)
    window.history.pushState({}, '', '?' + this.query.toString())
    this.reloadGrids()

    if (updateCalendar && this.calendar.instance) this.updateCalendar()
  }

  initCalendar() {
    const data = this.query.get('data')
    this.calendar = new Calendar(data ? [data] : null)

    if (this.calendar.instance) {
      this.calendar.onUpdate = this.onUpdate.bind(this)
      this.updateCalendar()
    }
  }

  initGrids() {
    this.grids = []
    const jsGrids = document.querySelectorAll('.js-grid')

    jsGrids.forEach((element) => {
      const grid = new Grid(element)
      this.grids.push(grid)
    })

    this.reloadGrids()
  }

  async reloadGrids() {
    let empties = 0

    for (let grid of this.grids) {
      await grid.init(this.query.toString())

      grid.toggle(grid.isEmpty)
      if (grid.isEmpty) empties++
    }

    this.emptyElement.classList.toggle(
      'is-hidden',
      empties != this.grids.length
    )
  }

  updateCalendar() {
    API.getEventsDays(this.query.toString()).then((result) => {
      this.calendar.setEventsDays(result)
    })
  }
}

export const Index = new CIndex()
